import createRequestSlice, { requestInitialState } from 'redux/request/reducer';

export const PREFIX = 'states';

export const initialState = {
  ...requestInitialState,
  data: [],
};

const installersSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    fetch(state, { payload }) {
      return {
        ...state,
        data: [...payload],
      };
    },
  },
});

export const actions = { ...installersSlice.actions };
export const requests = { ...installersSlice.requests };

export default installersSlice.reducer;
